import * as mt from "./mutation-types";
import { NotificationState, Notification } from "./types";

interface NotificationPayload {
  notification: Notification;
}
export default {
  [mt.ADD_NOTIFICATION](
    state: NotificationState,
    { notification }: NotificationPayload
  ) {
    state.notifications.push(notification);
  },

  [mt.CLEAR_NOTIFICATION](
    state: NotificationState,
    { notification }: NotificationPayload
  ) {
    state.notifications = state.notifications.filter(n => n !== notification);
  }
};
